import { fetchProductsCategoriesData, ProductsCategoriesPage } from 'src/modules/products';

export const getStaticProps = async () => {
  const data = await fetchProductsCategoriesData();
  return { props: { productCategories: data } };
};

export default ProductsCategoriesPage;
